import { render, staticRenderFns } from "./TimesheetChip.vue?vue&type=template&id=b038530a&scoped=true&"
import script from "./TimesheetChip.vue?vue&type=script&lang=js&"
export * from "./TimesheetChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b038530a",
  null
  
)

export default component.exports